import { render, staticRenderFns } from "./ImageThumbnail.vue?vue&type=template&id=388ba934"
import script from "./ImageThumbnail.vue?vue&type=script&lang=js"
export * from "./ImageThumbnail.vue?vue&type=script&lang=js"
import style0 from "./ImageThumbnail.vue?vue&type=style&index=0&id=388ba934&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports